// Importante:
// la licencia de la Academia se guarda al momento de loguearse y se actualiza al momento de cambiar el plan,
// los recursos consumidos por la Academia se guardan al momento de loguearse y se actualizan al momento de ejecutarse algún endpoint relacionado
// academyResources (los recursos consumido por la Academia hasta el momento)
// licenseFeatures (los recursos y características permitidos por la licencia de la Academia)

import abilities from '@/plugins/permissions/abilities'
import configApp from '@/config'
import permissions from '@/plugins/permissions'
import store from '@/store'
import Vue from 'vue'

let license = new Vue({

  data () {
    return {
      maximumReached: []
    }
  },

  computed: {
    academyResources () {
      return store.getters.getAcademyResources
    },

    licenseFeatures () {
      return store.getters.getAcademyData.licencia
    },

    shouldUpgrade () {
      return this.maximumReached.includes(true)
    }
  },

  watch: {
    academyResources () {
      this.setPermissions()
    }
  },

  methods: {
    isMaximumReached (resource) {
      let result = false
      switch (resource) {
        case 'administradores':
          result = this.academyResources.administradores >= this.licenseFeatures.maximo_administradores
          break

        case 'alumnos':
          result = this.academyResources.alumnos >= this.licenseFeatures.maximo_alumnos
          break

        case 'instructores':
          result = this.academyResources.instructores >= this.licenseFeatures.maximo_instructores
          break

        case 'mapas':
          result = this.academyResources.mapas >= this.licenseFeatures.maximo_mapas
          break

        case 'productos':
          result = this.academyResources.productos >= this.licenseFeatures.maximo_productos
          break

        case 'profesores':
          result = this.academyResources.profesores >= this.licenseFeatures.maximo_profesores
          break

        case 'proyectos':
          result = this.academyResources.proyectos >= this.licenseFeatures.maximo_proyectos
          break

        case 'puntosVenta':
          result = this.academyResources.puntos_venta >= this.licenseFeatures.maximo_puntos_venta
          break

        default:
          result = false
      }

      return result
    },

    readAcademiaConfiguracionGlobal () {
      this.$services.read('academia', 'readAcademiaConfiguracionGlobal', {}, [store.getters.getAcademyData.id])
        .then(response => {
          store.commit('setAcademyGlobalConfiguration', Object.assign({}, response.data))
        })
        .catch(error => {
          console.log(error)
        })
    },

    readAcademiaRecursosUsados () {
      if (configApp.vidroopAcademyId !== store.getters.getAcademyData.id) {
        this.$services.read('academia', 'readAcademiaRecursosUsados', {}, [store.getters.getAcademyData.id])
          .then(response => {
            localStorage.setItem('current_resources', JSON.stringify(response.data))
            store.commit('setAcademyResources', response.data)
          })
          .catch(error => {
            console.log(error)
          })
      }
    },

    setPermissions () {
      let currentAbility = store.getters.getAcademyData.current_ability
      let currentPermissions = [...abilities[currentAbility]]
      this.maximumReached = []

      currentPermissions.push(
        {
          action: 'access',
          subject: 'MoleculeEditionAcademyAutoresponders',
          inverted: !this.licenseFeatures.integraciones
        }
      )

      currentPermissions.push(
        {
          action: 'create',
          subject: 'createInscripcionManual',
          inverted: this.academyResources.alumnos >= this.licenseFeatures.maximo_alumnos
        }
      )
      this.maximumReached.push(this.academyResources.alumnos >= this.licenseFeatures.maximo_alumnos)

      currentPermissions.push(
        {
          action: 'create',
          subject: 'createProducto',
          inverted: this.academyResources.productos >= this.licenseFeatures.maximo_productos
        }
      )
      this.maximumReached.push(this.academyResources.productos >= this.licenseFeatures.maximo_productos)

      currentPermissions.push(
        {
          action: 'create',
          subject: 'createProductoClonar',
          inverted: this.academyResources.productos >= this.licenseFeatures.maximo_productos
        }
      )
      this.maximumReached.push(this.academyResources.productos >= this.licenseFeatures.maximo_productos)

      currentPermissions.push(
        {
          action: 'create',
          subject: 'createProyecto',
          inverted: this.academyResources.proyectos >= this.licenseFeatures.maximo_proyectos
        }
      )
      this.maximumReached.push(this.academyResources.proyectos >= this.licenseFeatures.maximo_proyectos)

      currentPermissions.push(
        {
          action: 'create',
          subject: 'createProyectoClonar',
          inverted: this.academyResources.proyectos >= this.licenseFeatures.maximo_proyectos
        }
      )
      this.maximumReached.push(this.academyResources.proyectos >= this.licenseFeatures.maximo_proyectos)

      currentPermissions.push(
        {
          action: 'create',
          subject: 'createMapa',
          inverted: this.academyResources.mapas >= this.licenseFeatures.maximo_mapas
        }
      )
      this.maximumReached.push(this.academyResources.mapas >= this.licenseFeatures.maximo_mapas)

      currentPermissions.push(
        {
          action: 'create',
          subject: 'createMapaClonar',
          inverted: this.academyResources.mapas >= this.licenseFeatures.maximo_mapas
        }
      )
      this.maximumReached.push(this.academyResources.mapas >= this.licenseFeatures.maximo_mapas)

      currentPermissions.push(
        {
          action: 'update',
          subject: 'updateInscripcionEstado',
          inverted: this.academyResources.alumnos >= this.licenseFeatures.maximo_alumnos
        }
      )
      this.maximumReached.push(this.academyResources.alumnos >= this.licenseFeatures.maximo_alumnos)

      currentPermissions.push(
        {
          action: 'create',
          subject: 'createPuntoVenta',
          inverted: this.academyResources.puntos_venta >= this.licenseFeatures.maximo_puntos_venta
        }
      )
      this.maximumReached.push(this.academyResources.puntos_venta >= this.licenseFeatures.maximo_puntos_venta)

      permissions.update(currentPermissions)
    }
  }
})

export default {
  install: (Vue) => {
    Vue.prototype.$license = license
  }
}
